/**
 * @license
 * Copyright (c) 2021 Handsoncode. All rights reserved.
 */
export class ContentChanges {
    constructor() {
        this.changes = [];
    }
    static empty() {
        return new ContentChanges();
    }
    addAll(other) {
        this.changes.push(...other.changes);
        return this;
    }
    addMatrixChange(newValue, address) {
        for (const [matrixValue, cellAddress] of newValue.generateValues(address)) {
            this.addSingleCellValue(matrixValue, cellAddress);
        }
    }
    addChange(newValue, address) {
        this.addSingleCellValue(newValue, address);
    }
    add(...change) {
        this.changes.push(...change);
    }
    exportChanges(exporter) {
        const ret = [];
        this.changes.forEach((e, i) => {
            ret[i] = exporter.exportChange(this.changes[i]);
        });
        return ret;
    }
    getChanges() {
        return this.changes;
    }
    isEmpty() {
        return this.changes === [];
    }
    addSingleCellValue(value, address) {
        this.add({
            sheet: address.sheet,
            col: address.col,
            row: address.row,
            value,
        });
    }
}
